import { render, staticRenderFns } from "./EmptyBookingIcon.vue?vue&type=template&id=82187788"
import script from "./EmptyBookingIcon.vue?vue&type=script&lang=js"
export * from "./EmptyBookingIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports